import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onBeforeUnmount, toRefs } from 'vue'
import { useStore } from 'vuex'
import LayerHeatmap from './heatmaps/LayerHeatmap.vue'
import LayerSensorData from './LayerSensorData.vue'
import { collectSensorData, getPresence } from '@/utils/format-sensor-values'
import { SENSOR_DATA_ROOM } from '@/interfaces/sensordata.interface'

interface PROPS {
  before: string
  layerIdSensorData: string
}
const sourceIdSensorData = 'source-room-sensor-data'


export default /*@__PURE__*/_defineComponent({
  __name: 'LayerRoomData',
  props: {
    before: {},
    layerIdSensorData: {}
  },
  setup(__props: any) {

const store = useStore()

const props = __props
const { before, layerIdSensorData } = toRefs(props)
const roomsForSelectedLevel = computed(() => store.state.roomsForSelectedLevel)
const currentSensordataType = computed<string | null>(
  () => store.state.planview.currentSensordataType
)
const sensorDataForSelectedLevel = computed<SENSOR_DATA_ROOM[]>(
  () => store.state.planview.sensorDataForSelectedLevel
)

const source = computed(() => {
  if (!roomsForSelectedLevel.value || !sensorDataForSelectedLevel.value.length) return null

  const roomsWithGeometry = roomsForSelectedLevel.value.data.features.filter(
    (room) => room.geometry
  )
  roomsWithGeometry.forEach((room) => {
    const roomData = sensorDataForSelectedLevel.value.find(
      (roomSensorValues) => roomSensorValues.objectId === room.properties.id
    )
    if (!roomData) return
    room.properties.temperature = collectSensorData(roomData, 'Temperature')
    room.properties.co2 = collectSensorData(roomData, 'CO2')
    room.properties.presence = getPresence(roomData)
    room.properties.humidity = collectSensorData(roomData, 'Humidity')
    room.properties.flow = collectSensorData(roomData, 'Flow')
  })

  return {
    type: 'geojson',
    data: {
      id: sourceIdSensorData,
      type: 'FeatureCollection',
      features: roomsWithGeometry
    }
  }
})

onBeforeUnmount(() => {
  store.commit('planview/SET_IS_SENSORDATA_SHOWING', { value: false })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (currentSensordataType.value === 'wifi')
      ? (_openBlock(), _createBlock(LayerHeatmap, {
          key: 0,
          before: _unref(before)
        }, null, 8, ["before"]))
      : _createCommentVNode("", true),
    (source.value && currentSensordataType.value && currentSensordataType.value !== 'wifi')
      ? (_openBlock(), _createBlock(LayerSensorData, {
          key: 1,
          before: _unref(before),
          layerId: _unref(layerIdSensorData),
          source: source.value,
          currentSensordataType: currentSensordataType.value
        }, null, 8, ["before", "layerId", "source", "currentSensordataType"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})